(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name finance.kkcat.factory:Kkcat
   *
   * @description
   *
   */
  angular
    .module('finance.vckkcat')
    .factory('Kkcat', Kkcat);
  
  
  Kkcat.$inject = ['restmod'];
  function Kkcat(restmod) {
    return restmod.model('/routes/kkcats').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/kkcats/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return $search({key, val});
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
